module.exports = __webpack_public_path__ + "img/GreekTechSpearman1_ua.1516b276.webp";